<template>
  <UnopenedLeadCard @close="close" :lead="lead">
    <template #openLabel>
      Add Funds!
    </template>

    <div class="d-flex">
      <div 
        class="mt-5 rounded-lg px-4 py-3 d-flex align-center justify-center" 
        style="border: 1px solid #7D8E9B; width: 50%"
      >
        <div class="text-center">
          This lead costs {{ $formatters.formatCurrency(lead.price_cents) }} (+ tax).
        </div>
      </div>

      <div 
        class="mt-5 rounded-lg ml-2 px-4 py-3 d-flex elevation-2 align-center justify-center primary white--text"
        style="width: 50%"
        @click="open"
      >
        <div class="text-center d-flex flex-column">
          <div style="font-size: 16px; font-weight: bold;">ADD FUNDS</div>
        </div>
      </div>
    </div>
    <div class="mt-5">
      Your balance is {{ $formatters.currency(me.balance_cents) }}, but this lead
      will cost {{ $formatters.currency(lead.price_cents) }} <em>(+ tax)</em>.
      You need to add to your balance to claim this lead.
    </div>

    <div class="mt-5">
      Sharing is caring! <span class="blue--text text--darken-2">Most of what we collect goes back
      to the person who sent this lead</span>.
    </div>
  </UnopenedLeadCard>
</template>

<script>
import UnopenedLeadCard from './UnopenedLeadCard.vue'

import { mapGetters } from 'vuex'

export default {
  name: 'UnopenedLeadInsufficient',

  components: { UnopenedLeadCard },

  props: {
    lead: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters('auth', ['me']),
  },

  methods: {
    close() {
      this.$emit('close')
    },

    open() {
      this.$router.push( { name: 'billing/add_balance' })
    },
  }
}
</script>